import React from "react";
import UiMainWrapper from "../../components/common/UiMainWrapper";
import TopHeader from "../../components/header/TopHeader";
import quizBanner from "../../../../styles/img/quiz-banner.png";
import { UiBannerBottomBar } from "../../components/common/UiBannerBottomBar";
import KnowledgeInnerBanner from "./Views/KnowledgeInnerBanner";
import { UiContentCol, UiContentWr } from "../../components/common/UiPageElements";
import { UiCol, UiRowContainer, UiSingleRow } from "../../components/grid-container/GridContainer";
import Footer from "../../components/footer/Footer";
import { UiBlueBox } from "../../../_uiComponents/common/UiBlueBox";
import { Button } from "react-bootstrap";
import { QuestionLinks } from "../../../_uiComponents/common/QuestionLinks";
import { CircleTick } from "../../../../styles/img/svg/CircleTick";
import { UiQuestionWrapper } from "../../../_uiComponents/common/UiQuestionWrapper";
import { ImageQuestionAnswers } from "./Views/ImageQuestionAnswers";
import { ImageQuestionAnswerRadio } from "./Views/ImageQuestionRadio";
import { NeedAHelp } from "./Views/NeedAHelp";
import questionPhoto from '../../../../styles/img/knowledge-progress.jpg';
import questionPhoto3 from "../../../../styles/img/spin-win-2.jpg";
import questionPhoto4 from "../../../../styles/img/spin-win-3.jpg";
import questionPhoto5 from "../../../../styles/img/spin-win-4.jpg";
import KnowledgeInnerBanerQuiz from "./Views/KnowledgeInnerBannerQuiz";
import { useNavigate } from "react-router-dom";
import ToyotaInnerBanner from '../../../../styles/img/knowledge-inner-quiz.png'

export const SelectCorrectImage = (props) => {
    let navigate = useNavigate(); 
    const nextQuiz = () =>{ 
        let path = `../../ui/template-mcq-multiple`; 
        navigate(path, { replace: true });
    }
    return (
        <>
            <UiMainWrapper>
                <TopHeader />

                <KnowledgeInnerBanner
                    innerBanner={ToyotaInnerBanner}
                    title="The All New Toyota bZ4X"
                    description="Is your knowledge up to scratch?"
                    sliderCardImage={quizBanner}
                    className="sb-knowldg-inner-banner" />

                <UiBannerBottomBar
                    prevPage="Learn"
                    prevPageLink=""
                    currentPage="  Q1 Product Quiz"
                    currentPageLink="" />

                <UiContentWr>
                    <UiRowContainer fluid="fluid" className="sb-img-q-template-page">
                        <UiContentCol>
                            <UiSingleRow>
                                <UiCol lg="3" className="sb-img-q-template-page__links">

                                    <UiBlueBox >
                                        <p>Questions Remaining</p>
                                        <h3>3</h3>
                                    </UiBlueBox>

                                    <QuestionLinks className="sb-green-links">
                                        <li className="active"><a href="#"> <CircleTick /> My Progress</a></li>
                                        <li><a href="#"><CircleTick />  Section 1</a></li>
                                        <li><a href="#"><CircleTick />  Section 2</a></li>
                                        <li><a href="#"><CircleTick />  Section 3</a></li>
                                        <li><a href="#"><CircleTick />  Section 4</a></li>
                                        <li><a href="#"><CircleTick />  Section 5</a></li>
                                    </QuestionLinks>


                                </UiCol>
                                <UiCol lg="9" className="sb-img-q-template-page__content">
                                    <UiQuestionWrapper>
                                        <h3><span>Question 2:</span> What gives the bZ4X a superior cruising range?</h3>

                                        <p className="sb-1-instruction">Select one of the following:</p>

                                        <ImageQuestionAnswers>

                                            <ImageQuestionAnswerRadio
                                                id="radio-1"
                                                name="radio"
                                                for="radio-1"
                                                label="Blind Spot Monitor"
                                                 />

                                            <ImageQuestionAnswerRadio
                                                id="radio-2"
                                                name="radio"
                                                for="radio-2"
                                                label='Heated driver & front passenger seats'
                                                 />

                                            <ImageQuestionAnswerRadio
                                                id="radio-3"
                                                name="radio"
                                                for="radio-3"
                                                label="20 Alloy wheels"
                                                />

                                            <ImageQuestionAnswerRadio
                                                id="radio-4"
                                                name="radio"
                                                for="radio-4"
                                                label="12.3 HD Toyota Smart Connect"
                                                 />

                                            <ImageQuestionAnswerRadio
                                                id="radio-5"
                                                name="radio"
                                                for="radio-5"
                                                label="Energy Saving Heat Pump"
                                                 />

                                            <ImageQuestionAnswerRadio
                                                id="radio-6"
                                                name="radio"
                                                for="radio-6"
                                                label="Emergency steering Assist"
                                                 />

                                        </ImageQuestionAnswers>
                                        <div className="row">
                                        <div className="col-4">
                                        <Button className="sb-geen-btn" onClick={nextQuiz}>Submit?</Button>
                                    </div></div>
                                    </UiQuestionWrapper>

                                </UiCol>
                            </UiSingleRow>
                        </UiContentCol>
                    </UiRowContainer>
                </UiContentWr>

                <NeedAHelp />

                <Footer />

            </UiMainWrapper>


        </>
    )
}